import { NativeModules } from 'react-native';
import { Logger } from '../../utils';
const { DeviceSetup } = NativeModules;

export const signOutOfNativePlatformModules = async (): Promise<void> => {
  if (DeviceSetup && DeviceSetup.signOut) {
    const result = await DeviceSetup.signOut();
    Logger.leaveBreadcrumb('signout native', {
      result,
    });
  } else {
    Logger.leaveBreadcrumb('signout native', {
      message: 'nothing to do',
    });
  }
};
